import request from '../kernel/request'

export default {
	detail(id) {
		return request.get('company/detail/' + id)
	},
	edit(id) {
		return request.get('company/edit/' + id)
	},
	page(params) {
		return request.get('company/page', params)
	},
	myPage(params) {
		return request.get('company/myPage', params)
	},
	save(data) {
		return request.post('company/save', data)
	},
	update(data) {
		return request.put('company/update', data)
	},
	upState(id) {
		return request.put('company/upState/'+ id)
	},
	uploadProof: `${request.baseURL}/company/uploadProof`,
	uploadAttachment: `${request.baseURL}/company/uploadAttachment`,
}